module.exports = __webpack_public_path__ + "static/media/p.29bf5af5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/p.mp3
// module id = 105
// module chunks = 0